export const store = {
  // 横竖屏状态, landscape->横屏 portrait->竖屏
  screenState: '', 
  // key-value 多语言内容
  langConfig: {},
  userInfo: {},
  loading: {
    isShow: true,
    showType: 1
  },
}